<template>
    <v-card class="bg-card mb-2">
        <v-card-text class="px-0 pt-0 pb-0">
            

            <LocalTable :model="model" modelLinesProp='products' not-editable no-hover dense :dt="tblLines">
                
                <template v-slot:menu ="{ item }">
                    <ActionMenuItem icon="edit" :model="model" action="workorder_product.open" @click="()=>onOpenProductLine(item)">Wijzig regel</ActionMenuItem>
                    <v-divider></v-divider>
                    <ActionMenuItem :model="model" action="workorder.modify" icon="remove" @click="tblLines.onStartCheckBox(item, 'remove')">Verwijder regel</ActionMenuItem>
                </template>

                <template v-slot:commands ="{dt, bulkAction, selectedCount}">
                    <ActionButton main primary icon="remove" v-if="dt.bulkAction=='remove'"  @click="()=>onBulkRemoveProducts()" :disabled="!dt.selectedCount" >Verwijder</ActionButton>
                </template>

                <template v-slot:item.pd_name ="{ item }">
                    <span class="text-primary cursor-pointer" @click='()=>onOpenProductLine(item)'> {{ item.pd_name   }}</span>
                </template>

                <template v-slot:item.pd_code ="{ item }">
                    <span class="text-primary cursor-pointer" @click='()=>onOpenProductLine(item)'> {{ item.pd_code   }}</span>
                </template>

                <template v-slot:item.is_office_created ="{ item }">
                    <span class="position-relative" style="top:-2px;">
                        <Icon color="primary" xsize="xs" v-if="!!Number(item.is_office_created)" type='bank' title="Aangemaakt op kantoor"></Icon>
                        <Icon v-else color="warning" type='workorder' title="Aangemaakt in werkbon app"></Icon>
                    </span>
                </template>
                
                <template v-slot:bottom-commands="{/*dt, hasCmd, */columnHeaders}">
                    <v-divider></v-divider>
                    <div class="pa-4 pb-2">
                        <ActionButton sub action="workorder.modify" dusk="btn-add-line" :model="model" icon="add" @click='(evt)=>addProduct(evt)'>Materialen toevoegen</ActionButton>
                    </div>
                </template>

            </LocalTable>
        </v-card-text>

        <Prompt title="Wijzig materiaal" save="Opslaan" :model="prompt">            
            <FormRow label="Aantal">    
                <NumberField max="1000000" decimal dusk="amount" :model='model' v-model='prompt.quantity' ></NumberField>
            </FormRow>
            <FormRow label="Eenheid">
                <UnitCombo dusk="unit" :model='model' v-model='prompt.id_unit'></UnitCombo>
            </FormRow>

            <FormRow label="Artikel">    
                <ProductPicker 
                @select="(p)=>onSelectPromptProduct(p)" 
                    :filter="{'type': 'rp', 'selectfor':'salesinvoice'}" 
                    :model='model' 
                    :rules='prompt.mandatory' 
                    :value-model='prompt'
                    selectRepField="pd_name"
                    start-clean-search
                    repField="pd_name"
                    v-model='prompt.id_product'></ProductPicker>
            </FormRow>
        </Prompt>

    </v-card>
</template>



<script setup>

import ActionButton from '@shared/ui/controls/buttons/ActionButton'
import LocalTable from '@datatable/LocalTable'  
import clsLocalTable from '@cls/clsLocalTable'
import ActionMenuItem from "@controls/menu/ActionMenuItem.vue";
import {ref} from 'vue'
import Icon from '@controls/icons/Icon'
import dlg from '@app/dlg'
import {amount} from '@shared/lib/numeric'
import ProductPicker from '@controls/picker/Product'
// import StatusChip from "@controls/widgets/StatusChip.vue";
import Prompt from '@shared/ui/dialogs/DialogCustomPrompt'
import clsDialogCustomPrompt from '@cls/clsDialogCustomPrompt'
import FormRow from '@controls/forms/FormRow'
import NumberField from '@controls/input/NumberField'
import UnitCombo from '@controls/combo/Unit'    

const selectedRow = ref(null)

const props = defineProps({
    model: {
        type: [Object]
    },
    invTriggerCnt: {
        type: [Number, String]
    }
});
const emit = defineEmits(['onCreateInvoice', 'save'])

let headers = [

    { canhide: false, canmove: false, type: 'cmd'}, 

    { canhide: false, canmove: false, text: "", value: "is_office_created"  ,class:"w-1"},
    { text: "Aantal",                  value: "quantity"   ,class:"w-3"          },
    { text: "Eenheid",                  value: "un_name"   ,class:"w-3"          },
    { text: "Artikelcode",              value: "pd_code"   ,class:"w-4"          },
    { text: "Artikel",                  value: "pd_name"             },
    { visible: false, text: "Inkoopprijs excl. BTW",    value: "purchase_price_excl_vat", type: 'amount'}, 
    { visible: false, text: "Inkoopprijs totaal excl. BTW",    value: "purchase_price_total_excl_vat", fmt: (v,V,item)  => amount.fmt((item.quantity||0)*(item.purchase_price_excl_vat||0)) }, 
    { text: "Verkoopprijs excl. BTW",   value: "sales_price_excl_vat", type: 'amount' },
    { text: "Verkoop totaal excl. BTW",   value: "sales_price_total_excl_vat", fmt: (v,V,item)  => amount.fmt((item.quantity||0)*(item.sales_price_excl_vat||0)) },
    { visible: false, text: "Fabrikant",           value: "sup_name"            },
    { visible: false, text: "Fabrikantcode",   value: "pd_supplier_code"    },
    { visible: false, text: "Fabrikantnaam",   value: "pd_supplier_name"    },
    { visible: false, text: "Ean",                value: "ean"                 },
];



let tblLines = ref(new clsLocalTable("workorder.products", headers, {
    noDataText: "Er zijn nog geen materialen toegevoegd",
    noSort: true,
    model: props.model, 
    modelLinesProp: 'products',   
}));

async function addProduct(){
        try {
            var fnMultiSelectCallback = function(selected) {
                if (!selected || !selected.length) {
                    return;
                }
                console.log("Selected product:", selected[0]);
                props.model.addProductLine(selected[0]);                
            }

            await dlg.promised.open("select_product", {multiselect:false, fnMultiSelectCallback: fnMultiSelectCallback, filter: {type: 'rp'}}) // rp: recipes and products
        } catch (e) { return; }
}

function onBulkRemoveProducts(line) {
    var ids = tblLines.value.selectedIDs(); 
    props.model.removeProductLines(ids);
}


let prompt = ref(new clsDialogCustomPrompt(["quantity", "id_unit", "id_product", "pd_name"])).value;

// Open the product line in a custom prompt for updating.
async function onOpenProductLine(item) {
  var result = await prompt.setData({
        quantity: item.quantity, 
        id_unit: item.id_unit, 
        id_product: item.id_product, 
        pd_name: item.pd_name
    }).prompt( 
        async (obj) => {
            props.model.updateProductLine({idLine: item.id, quantity: obj.quantity, id_unit: obj.id_unit, id_product: obj.id_product});
            console.log('Received data', obj, item);
            item.quantity = obj.quantity;
            item.id_unit = obj.id_unit;
            item.id_product = obj.id_product;
            item.pd_name = obj.pd_name;
        }
    )
}
// In the prompt, when a product is selected, take the information from the product 
// and update the prompt values.
function onSelectPromptProduct(pickedProduct) {
    prompt.id_product = pickedProduct.id;
    prompt.pd_name = pickedProduct.pd_name;
    prompt.id_unit = pickedProduct.id_unity;

    if (undefined !== pickedProduct.amount && null !== pickedProduct.amount) {
        prompt.quantity = pickedProduct.amount;
    }

    console.log("onSelectedPromptProduct product", pickedProduct);
}

</script>